export const selectPaymentServiceConf = (state = {}) => (state.PAYMENT_SERVICE_CONF !== undefined
  ? state.PAYMENT_SERVICE_CONF
  : {});

export const paymentServiceConfSelector = (state = initialState) => (state.payments.PAYMENT_SERVICE_CONF !== undefined
    ? state.payments.PAYMENT_SERVICE_CONF
    : {});

export const selectPaymentServiceResult = (state = {}) => (state.PAYMENT_SERVICE_RESULT !== undefined
      ? state.PAYMENT_SERVICE_RESULT
      : {});

export const selectPaymentServiceConfArrayServices = (state = {}) => (
        state && state.PAYMENT_SERVICE_CONF && state.PAYMENT_SERVICE_CONF.services
        ? state.PAYMENT_SERVICE_CONF.services : []);
  

export const selectOCRScannerData = (state = {}) => (
          state && state.OCR_SCANNER_DATA
          ? state.OCR_SCANNER_DATA : {});

export const selectContactNumberData = (state = {}) => (
  state && state.SET_NUMBER_CONTACTS
  ? state.SET_NUMBER_CONTACTS : null);
         
export const selectPaymentServiceContacts = (state = {}) => (
            state && state.PAYMENT_SERVICE_CONTACTS
            ? state.PAYMENT_SERVICE_CONTACTS : []);

export const getCanEncript = (state = initialState) =>{
  return state.payments.canEncrypt;
}

export const getServiceId = (state = initialState) =>{
  return state.payments.PAYMENT_SERVICE_CONF.services[0].serviceData.info.serviceId;
}

export const getSdkVersion = (state = initialState) =>{
  return state.payments.PAYMENT_SERVICE_CONF.sdkClaroVersion
}

export const getCanSendId = (state = initialState) =>{
  return state.payments.canSendServiceId
}

export const getHasCreditFromUrl = (state = initialState) =>{
  return state.payments.hasCredit
}

export const getCanSendClaroSocioValue = (state = initialState) =>{
  return state.payments.canSendClaroSocioValue
}

export const getCanShowCanCookiesValue = (state = initialState) =>{
  return state.payments.canShowCanCookies
}

export const getParamsFromUrl = (state = initialState) =>{
  return state.payments.params;
}
export const getBundleVersionFromUrl = (state = initialState) =>{
  return state.payments.bundleVersion;
}

export const getBundleIdFromUrl = (state = initialState) =>{
  return state.payments.bundleId;
}

export const getUserInfoSelector = (state = initialState) =>{
  return state.payments.userInfo
}

export const getAppSyncValues = (state = initialState) =>{
  return state.payments.appSyncValues
}
export const getUserInfoLiteSelector = (state = initialState) =>{
  return state.payments.userInfoLite
}

export const getCodeError = (state = initialState) =>{
  return state.payments.codeError
}
export const getMessageSears = (state = initialState) =>{
  return state.payments.searsMessages;
}

export const getTagServiceId = (state = initialState) =>{
  return state.PAYMENT_SERVICE_CONF.tagServiceId;
}

export const getListFavsServices = (state = initialState) =>{
  return state.ResponseSuccess.favorite;
}
export const getMessageFavServices = (state = initialState) =>{
  return state.favoriteServicesMessages;
}

export const getPendingAmount = (state = initialState) =>{
  return state.pendingAmount
};

export const isTemporalClaroIdSelector = (state = initialState) =>{
  return state.payments.isTemporalClaroId
};

export const isAnonimousSelector = (state = initialState) =>{
  return state.payments.isAnonimous
};
export const isContainerTelcelSelector = (state = initialState) =>{
  return state.payments.isContainerTelcel
};